import {Injectable} from '@angular/core';
import {GraphicDataService} from './graphic-data.service';
import {Observable, of, throwError} from 'rxjs';
import {tap} from 'rxjs/operators';

export interface Graphic {
  id: number;
  type: string;
  image: string;
}

interface SavedGraphic {
  savedAt: number;
  graphic: Graphic;
}

@Injectable({
  providedIn: 'root'
})
export class GraphicService {

  private readonly hour = 1000 * 60 * 60;

  constructor(private readonly graphicDataService: GraphicDataService) {
  }

  fetchGraphic(id: number): Observable<Graphic> {
    if (!id) {
      return throwError(() => `unable to fetch graphic given id ${id}`);
    }

    const loaded = this.loadGraphic(id);
    return loaded || this.graphicDataService.fetchGraphic(id).pipe(tap(g => g && this.saveGraphic(g)));
  }

  private loadGraphic(id: number): Observable<Graphic> {
    const found = localStorage.getItem('' + id);
    const parsed: SavedGraphic = found && JSON.parse(found);
    if (parsed && new Date().getTime() - parsed.savedAt <= this.hour) {
      console.debug(`Returning saved graphic for id: ${id}`);
      return of(parsed.graphic);
    } else {
      console.debug(`Not returning saved graphic for id: ${id}`);
    }
    return null;
  }

  saveGraphic(g: Graphic, date = new Date()) {
    localStorage.setItem('' + g.id, JSON.stringify({savedAt: date.getTime(), graphic: g}));
  }

}
